import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=cb770ee6&scoped=true"
import script from "./Markets.vue?vue&type=script&lang=js"
export * from "./Markets.vue?vue&type=script&lang=js"
import style0 from "./Markets.vue?vue&type=style&index=0&id=cb770ee6&prod&lang=scss&scoped=true"
import style1 from "./Markets.vue?vue&type=style&index=1&id=cb770ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb770ee6",
  null
  
)

export default component.exports